import { Box as MuiBox } from "@mui/material";
import { cn } from "@/src/shared/utils/mergeTwClasses";

export function Card({
    onHintCardDetailsButtonPressed,
    boxShadow,
    ...props
}: any) {
  return <MuiBox {...props} className={cn("flex flex-col", props.className)} />;
}
